const EMPLOYEE_NAME_FORMAT_STORAGE_KEY =
    'employee-workforce:name-format:v1';
const DEFAULT_EMPLOYEE_NAME_FORMAT = 'short';

const EMPLOYEE_NAME_FORMAT_OPTIONS = [
    {
        value: 'full',
        label: 'Полностью',
        example: 'Иванов Иван Иванович'
    },
    {
        value: 'initials',
        label: 'С инициалами',
        example: 'Иванов И.И.'
    },
    {
        value: 'short',
        label: 'Без отчества',
        example: 'Иванов Иван'
    }
];

const FORMAT_VALUES = new Set(
    EMPLOYEE_NAME_FORMAT_OPTIONS.map(function (option) {
        return option.value;
    })
);

function clean(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
}

function parsedName(employee) {
    const value = employee || {};
    let lastName = clean(value.last_name);
    let firstName = clean(value.first_name);
    let middleName = clean(value.middle_name);
    const fullParts = clean(value.full_name).split(' ').filter(Boolean);
    const displayParts = clean(value.display_name).split(' ').filter(Boolean);

    if (!lastName) lastName = fullParts[0] || displayParts[0] || '';
    if (!firstName) firstName = fullParts[1] || displayParts[1] || '';
    if (!middleName && fullParts.length > 2) {
        middleName = fullParts.slice(2).join(' ');
    }
    return {lastName, firstName, middleName};
}

function initial(value) {
    const letter = clean(value).replace(/\./g, '').charAt(0);
    return letter ? `${letter.toLocaleUpperCase('ru-RU')}.` : '';
}

function normalizeEmployeeNameFormat(value) {
    return FORMAT_VALUES.has(value) ? value : DEFAULT_EMPLOYEE_NAME_FORMAT;
}

function formatEmployeeName(employee, format) {
    const value = employee || {};
    const parts = parsedName(value);
    const normalizedFormat = normalizeEmployeeNameFormat(format);
    let result = '';

    if (normalizedFormat === 'full') {
        result = [parts.lastName, parts.firstName, parts.middleName]
            .filter(Boolean)
            .join(' ');
    } else if (normalizedFormat === 'initials') {
        const initials = `${initial(parts.firstName)}${initial(parts.middleName)}`;
        result = [parts.lastName, initials].filter(Boolean).join(' ');
    } else {
        result = [parts.lastName, parts.firstName].filter(Boolean).join(' ');
    }

    return clean(result)
        || clean(value.display_name)
        || clean(value.full_name)
        || clean(value.name)
        || `Сотрудник #${value.employee_id || value.id || ''}`.trim();
}

function employeeNameCopyPayload(employees, format, previewLimit, includeDetails = false) {
    const values = Array.isArray(employees) ? employees : [];
    const names = values.map(function (employee) {
        const name = formatEmployeeName(employee, format);
        if (!includeDetails) return name;
        const value = employee || {};
        const hiringForm = value.hiring_form === 'gph' ? 'ГПХ' : '';
        return [name, clean(value.citizenship), hiringForm].filter(Boolean).join(' · ');
    }).filter(Boolean);
    const limit = Number.isFinite(Number(previewLimit))
        ? Math.max(0, Number(previewLimit))
        : 3;
    return {
        names,
        text: names.join('\n'),
        preview: names.slice(0, limit),
        remaining: Math.max(0, names.length - limit)
    };
}

function readEmployeeNameFormat(storage) {
    try {
        const target = storage || (
            typeof window !== 'undefined' ? window.localStorage : null
        );
        return normalizeEmployeeNameFormat(
            target && target.getItem(EMPLOYEE_NAME_FORMAT_STORAGE_KEY)
        );
    } catch (error) {
        return DEFAULT_EMPLOYEE_NAME_FORMAT;
    }
}

function writeEmployeeNameFormat(value, storage) {
    const normalized = normalizeEmployeeNameFormat(value);
    try {
        const target = storage || (
            typeof window !== 'undefined' ? window.localStorage : null
        );
        if (target) target.setItem(EMPLOYEE_NAME_FORMAT_STORAGE_KEY, normalized);
    } catch (error) {
        // Отображение должно работать и при запрещённом localStorage.
    }
    return normalized;
}

module.exports = {
    DEFAULT_EMPLOYEE_NAME_FORMAT,
    EMPLOYEE_NAME_FORMAT_OPTIONS,
    EMPLOYEE_NAME_FORMAT_STORAGE_KEY,
    employeeNameCopyPayload,
    formatEmployeeName,
    normalizeEmployeeNameFormat,
    readEmployeeNameFormat,
    writeEmployeeNameFormat
};
